<template>
  <div class="img-wrapper">
    <img
      :src="src"
      class="img"
      width="100"
      height="100"
      alt=""
    >
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.img-wrapper {
  position: relative;
  cursor: pointer;

  .img {
    border-radius: 4px;
    background-color: #313131;

    &:not([src]) {
      background-image: url('~@/assets/images/my-quiz-answer/placeholder.png');
      background-size: 33px;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
}

</style>
